import { atom } from 'recoil';

export const BreadcrumbsAtom = atom({
  key: 'BreadcrumbsAtom',
  default: [],
});
